import React from "react";

interface AlertProps {
  alert: string;
}

export default function Alert({ alert }: AlertProps) {
  return (
    <div
      className="alert alert-danger d-flex align-items-center gap-2 mb-0 p-2 border-danger"
      role="alert"
    >
      <i className="bi bi-x-circle-fill fs-2 lh-1 text-danger" />
      {alert}
    </div>
  );
}
